import React from 'react';
import styled from 'styled-components';
import { RoundButton } from '../shared/Buttons';
import FavoriteStar from '@client/assets/svgs/favorite-star.svg';

const Button = styled(RoundButton)`
	svg {
		padding: 5px;
	}
`;

interface IProps {
	backgroundColor: string;
	starColor: string;
	size: number;
	onClick?: () => void;
	className?: string;
}

export const FavouriteButtonCompact = (props: IProps) => {
	return (
		<Button
			className={props.className}
			colors={{
				bg: props.backgroundColor,
				fg: props.starColor,
			}}
			size={props.size < 40 ? 'xsmall' : 'small'}
			onClick={e => {
				e.preventDefault();
				e.stopPropagation();

				if (props.onClick) {
					props.onClick();
				}
			}}
		>
			<FavoriteStar />
		</Button>
	);
};
